/**
 * Адрес контракта: коротко на экране (`XsueG8…3bd1`), по клику копируется
 * целиком (15.10, терминал; с 15.10 и раздел xStocks). Целиком адрес
 * нечитаем и в строку не влезает, а для сверки «та ли это монета» хватает
 * начала и хвоста.
 */
import React, { useState } from 'react';
import { Check, Copy } from 'lucide-react';

export const shortAddr = (a: string): string =>
  a.length <= 12 ? a : `${a.slice(0, 6)}…${a.slice(-4)}`;

export const CopyAddr: React.FC<{ addr: string; label: string; className?: string }> = ({ addr, label, className }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(addr);
    } catch {
      // http или запрет браузера — старый способ через выделение
      const ta = document.createElement('textarea');
      ta.value = addr; document.body.appendChild(ta); ta.select();
      try { document.execCommand('copy'); } finally { ta.remove(); }
    }
    setDone(true);
    window.setTimeout(() => setDone(false), 1200);
  };
  return (
    <button type="button" onClick={(e) => { e.stopPropagation(); void copy(); }} title={`${addr}\n${label}`}
            aria-label={label}
            className={className ?? 'inline-flex items-center gap-1 rounded px-1 font-mono text-[12px] text-muted-foreground transition-colors hover:bg-foreground/5 hover:text-foreground'}>
      {shortAddr(addr)}
      {done ? <Check size={11} className="text-trade-green" /> : <Copy size={11} className="opacity-60" />}
    </button>
  );
};
